/**
 * Live totals for an unsaved draft, priced by the same package and in the same order as rest_server's
 * PUT /v4/estimates/:id: CAD forces fxRate 1, then validate, normalize, price. A preview only: the server
 * re-prices on save and its result is what gets stored.
 */
import {
  normalizeEstimateInputs, priceEstimate, validateEstimateInputs,
  type EstimateInputs, type FieldError, type MonitoringRates, type OfferType, type PriceBook, type PricingResult,
} from '@atek/estimate-pricing';

export interface LivePricing { result: PricingResult | null; errors: FieldError[] }

export function priceDraft(inputs: EstimateInputs, book: { id: string; version: number; rates: MonitoringRates }, offerType: OfferType): LivePricing {
  const prepared = inputs.currency === 'CAD' ? { ...inputs, fxRate: 1 } : inputs;
  const priceBook: PriceBook = { id: book.id, version: book.version, offerType, rates: book.rates };
  const errors = validateEstimateInputs(prepared, priceBook).map((e) => ({ ...e, path: e.path ? `inputs.${e.path}` : 'inputs' }));
  if (errors.length) return { result: null, errors };
  return { result: priceEstimate(normalizeEstimateInputs(prepared), priceBook), errors: [] };
}
